import toastStyles from "../static/messages/styles.scss";
import toastItemHtml from "../static/messages/index.html";
import { ImisMessageType } from "../models/imis.models";
import { ToastMessageProperties } from "../models/messages.models";

/**
 * MessagesUtility displays and manages inline status messages and dismissible/auto-dismissing toast notifications.
 */
export class MessagesUtility {
    /**
     * Shows an inline message paragraph, creating it (and appending it to the given parent) if it does not already exist, or updating its content, styling class, and visibility if it does.
     * @param messageId The id to assign to (or locate) the message element
     * @param message HTML content to display inside the message element
     * @param messageType The message type, applied as the element's CSS class to control its styling
     * @param parentSelector Selector or element the message element should be appended to when it is first created
     */
    public static showMessage(messageId: string, message: string, messageType: ImisMessageType, parentSelector: any) {
        let messageSelector = "#" + messageId;
        let jMessage = jQuery(messageSelector);
        if (jMessage.length == 0) {
            let jParent = jQuery(parentSelector);
            jMessage = jQuery("<p id='" + messageId + "'></p>").hide();
            jParent.append(jMessage);
        }

        jMessage.html(message).attr("class", messageType);
        jMessage.show();
    }

    /**
     * Hides an inline message element previously shown by {@link showMessage} without removing it from the DOM.
     * @param messageId The id of the message element to hide
     */
    public static hideMessage(messageId: string) {
        let messageSelector = "#" + messageId;

        let jMessage = jQuery(messageSelector);
        jMessage.hide();
    }

    /**
     * Removes an inline message element previously shown by {@link showMessage} from the DOM entirely.
     * @param messageId The id of the message element to remove
     */
    public static removeMessage(messageId: string) {
        let messageSelector = "#" + messageId;

        let jMessage = jQuery(messageSelector);
        jMessage.remove();
    }

    /**
     * Shows a toast notification, creating the shared toast container (and the individual toast item, if not already present) and lazily injecting the toast stylesheet. Toasts can either behave as a simple dismissible notice (click to close, with optional auto-dismiss after a delay) or, when a confirmation dialog is supplied, present confirm/cancel buttons that invoke the corresponding callback and remove the toast.
     * @param toastProperties Configuration for the toast, including its id, message text/type, auto-dismiss behavior, and an optional confirmation dialog (defaults applied via {@link ToastMessageProperties})
     */
    public static showToastMessage(toastProperties: ToastMessageProperties) {
        toastStyles.use();
        let toastPropertiesWithDefaults = Object.assign(new ToastMessageProperties(), toastProperties);

        // ensure the container already exists
        let jContainer = jQuery(".va-imis-utility-toast");
        if (jContainer.length == 0) {
            jContainer = jQuery("<div class='va-imis-utility-toast'></div>");
            jQuery("body").append(jContainer);
        }

        // ensure the message item already exists
        let jItem = jQuery("#" + toastPropertiesWithDefaults.messageId);
        if (jItem.length == 0) {
            jItem = jQuery(toastItemHtml);
            jItem.attr("id", toastPropertiesWithDefaults.messageId);
            jContainer.append(jItem);
        }

        // setup message item
        jItem.find("span:first-of-type").text(toastPropertiesWithDefaults.message);
        jItem.attr("class", "va-imis-utility-toast-item " + toastPropertiesWithDefaults.messageType);

        let jCloseSpan = jItem.find("span:last-of-type");
        let jButtons = jItem.find("button");
        jButtons.off("click");
        if (toastPropertiesWithDefaults.confirmationDialog != null) {
            // reset any existing click events and setup new button clicks and hide the close span
            jItem.off("click");

            jItem.find("button:first-of-type").on("click", () => {
                toastPropertiesWithDefaults.confirmationDialog.onConfirm();
                jItem.remove();
            });
            jItem.find("button:last-of-type").on("click", () => {
                toastPropertiesWithDefaults.confirmationDialog.onCancel();
                jItem.remove();
            });

            jCloseSpan.hide();
            jButtons.show();
        } else {
            // setup overall click event to dismiss toast
            jItem.on("click", () => {
                jItem.remove();
            });

            if (toastPropertiesWithDefaults.autoDismiss) {
                jItem.delay(toastPropertiesWithDefaults.autoDismissSeconds * 1000).fadeOut(() => {
                    jItem.remove();
                });
            }

            jCloseSpan.show();
            jButtons.hide();
        }
    }
}